/** The agent name `case-db-service` registers the page helper under; part of its thread key. */
export const PAGE_AGENT_NAME = "page-helper";

/** Catalog action whose detailed coding instructions are supplied by the server. */
export const CODE_MEDDRA_ACTION = "code_meddra";

/** The kinds of screen the dock can be told about. */
export const PAGE_KINDS = {
  caseReview: "CASE_REVIEW",
  workQueue: "WORK_QUEUE",
  assignmentCenter: "ASSIGNMENT_CENTER",
  dashboard: "DASHBOARD",
  caseSearch: "CASE_SEARCH",
  duplicateReview: "DUPLICATE_REVIEW",
  intakeTriage: "INTAKE_TRIAGE",
  configuration: "CONFIGURATION",
} as const;

export type PageKind = (typeof PAGE_KINDS)[keyof typeof PAGE_KINDS];

/** Advisory capabilities a screen may publish. Authorization stays server-side and in the executor. */
export const CAPABILITIES = {
  edit: "edit",
  route: "route",
  acceptAi: "accept_ai",
} as const;

export type Capability = (typeof CAPABILITIES)[keyof typeof CAPABILITIES];

/** Whether the reviewer is reading or changing the case. */
export const REVIEW_MODES = { read: "read", edit: "edit" } as const;

export type ReviewMode = (typeof REVIEW_MODES)[keyof typeof REVIEW_MODES];

/** Who holds the case's edit lock, as far as this browser knows. */
export const LOCK_STATES = { held: "held", heldByOther: "held_by_other", none: "none" } as const;

export type LockState = (typeof LOCK_STATES)[keyof typeof LOCK_STATES];

/** The `code` on the `RUN_ERROR` frame the server sends when a run was cancelled on request. */
export const RUN_CANCELLED_CODE = "RUN_CANCELLED";
/** The error code the clear route answers (409) while a run is running or queued on the thread. */
export const RUN_IN_PROGRESS_CODE = "RUN_IN_PROGRESS";

/** The `code` `@ag-ui/client` puts on the `RUN_ERROR` it synthesises when this browser aborts the stream. */
export const ABORT_CODE = "abort";

/**
 * How many runs one question may take. The server ends a run on every frontend call and the
 * browser starts the next one with the answer; this bounds that loop.
 */
export const MAX_AUTO_CONTINUE_RUNS = 8;

/** The card's state for a row whose proposal the form has let go of (Save, Cancel or a reload). */
export const PROPOSAL_CARD_CLOSED = "closed";
